import { useState } from 'react'

import {
  returnSalesRatioDescriptions,
  returnSalesRatioMetrics,
} from '@/metrics/components/ReturnSalesRatioCard/constants'
import { metricsDimensionTabs } from '@/metrics/constants'

const useReturnSalesRatioTabs = () => {
  const [selectedTab, setSelectedTab] = useState(metricsDimensionTabs.product)

  return {
    selectedTab,
    setSelectedTab,
    metrics: returnSalesRatioMetrics[selectedTab],
    description: returnSalesRatioDescriptions[selectedTab],
  }
}

export default useReturnSalesRatioTabs
